const Request = require('./BaseRequest')
const NotificationGraph = require('../graph/NotificationGraph')

module.exports = class NotificationRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new NotificationGraph(this.apiDomain)
    }

    // Add notification
    async createNotification(code, user_id, search_values, new_values, remarks, system_generated)
    { 
        let args = {code: code, user_id: user_id, search_values:search_values, new_values: new_values, remarks: remarks, system_generated: system_generated}
        let { type, query } = this.graph.setNotification(['id'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    //Get Notifications by User ID
    /**
     * 
     * @param {*} contact_id 
     * @param {*} code
     * @param {*} optional 
     * @returns 
     */
    notifications(user_id, contact_id, codes, optional={})
    {
        let args = {user_id: user_id, contact_id: contact_id, codes: codes, ...optional}

        let { type, query } = this.graph.notifificationsQuery([
            'id', 'notification_id', 'user_id', 'content', 'remarks', 'is_read', 'is_sent', 'created_at', 
            {notification: ['id','content','code','title','misc_data','is_active','created_at','updated_at','created_by']}], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }
}